var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHexagonal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_479",
    "data-name": "Group 479",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.077,
    height: 34,
    viewBox: "0 0 30.077 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M41.347,22.08a.636.636,0,0,0-.617,0L26.318,30.116a.617.617,0,0,0-.318.538V47.345a.617.617,0,0,0,.318.538L40.73,55.92a.636.636,0,0,0,.617,0l14.412-8.036a.617.617,0,0,0,.318-.538V30.655a.617.617,0,0,0-.318-.538ZM33.519,35.363l-6.266-3.629V46.269l6.266-3.606Zm6.893,18.96L27.885,47.337l6.271-3.609,6.256,3.367Zm7.517-20.028-6.294-3.387.026-7.231L54.2,30.664Zm-7.547-3.386.026-7.228L27.882,30.664,34.155,34.3Zm8.176,4.455,6.266-3.629V46.269l-6.266-3.606Zm-.637,8.365,6.271,3.609L41.665,54.322V47.094Z",
    transform: "translate(-26 -22)",
    fill: "#42dabf",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagonal);
export default __webpack_public_path__ + "static/media/hexagonal.c2e83be4.svg";
export { ForwardRef as ReactComponent };